<template>
  <layout>
    <template slot="header">Create notification</template>
    <v-combobox
      v-model="tags"
      :items="preFilled"
      multiple
      label="Tags"
      hide-selected
      clearable
      chips
      class="px-5"
    >
      <template v-slot:item="item">
        <div :data-test-tags="item.item">
          {{ item.item }}
        </div>
      </template>
      <template v-slot:selection="data">
        <v-chip small color="primary">
          {{ data.item }}
        </v-chip>
      </template>
    </v-combobox>
    <v-text-field
      data-test-message
      class="px-5"
      label="Message"
      clearable
      v-model="message"
    ></v-text-field>
    <template slot="footer">
      <v-spacer />
      <v-btn text @click="close" data-test-action="cancel">
        cancel
      </v-btn>
      <v-btn
        color="primary"
        :loading="loading"
        text
        @click.stop="save"
        data-test-action="send"
      >
        Send
      </v-btn>
    </template>
  </layout>
</template>

<script>
import Layout from '@/layouts/LayoutPopup';
import { ref } from '@vue/composition-api';
import useNoty from '@/api/notifications';
export default {
  name: 'SendNoty',
  props: {
    name: {
      type: String,
      default: ''
    }
  },
  components: {
    Layout
  },
  setup(props, { emit, root }) {
    const { notification } = useNoty();
    const loading = ref(false);
    const tags = ref([]);
    const preFilled = ref([
      'application',
      'triggered',
      'alert',
      'notice',
      'message'
    ]);
    const selectedUser = ref('');
    const message = ref('');
    const spec = ref('');

    function close() {
      emit('close');
    }

    async function save() {
      loading.value = true;
      let data = {
        objectId: root.$route.query?.nestedId || root.$route.params.id,
        objectName: props.name,
        tags: [...tags.value],
        message: message.value
      };

      notification
        .sendNotification({
          notification: data
        })
        .then(() => {
          emit('update');
          close();
        })
        .finally(() => {
          loading.value = false;
        });
    }

    return {
      save,
      close,
      tags,
      message,
      loading,
      spec,
      preFilled,
      selectedUser
    };
  }
};
</script>
